import axios from "../../utils/axios";

export const getAllTransactions = async () => {
  const response = await axios.get(`/transactions`);
  return response.data;
};

export const getTransactions = async (pageNo = 0, limit, type = "", search) => {
  let pagination = "";
  let sorting = "";
  let limitData = "";
  let queryString = "";

  // latest 5 items show
  sorting = `_sort=id&_order=desc`;

  // pagination
  pagination = pageNo > 0 ? `&_page=${pageNo}` : `&_page=1`;

  // limit data
  limitData = limit > 0 ? `&_limit=${limit}` : `&_limit=`;

  // queryString
  queryString = type !== "" ? `&type_like=${type}` : ``;

  // search
  if (search !== "") {
    queryString += `&q=${search}`;
  }

  const response = await axios.get(
    `/transactions/?${sorting}${pagination}${limitData}${queryString}`
  );

  return response.data;
};

export const addTransaction = async (data) => {
  const response = await axios.post("/transactions", data);
  if (response.data) {
    const resLanding = await axios.get(
      `/transactions/?_sort=id&_order=desc&_page=1&_limit=5`
    );
    const resAllLanding = await axios.get(`/transactions`);

    return {
      newItem: response.data,
      landingData: resLanding.data,
      allLanding: resAllLanding.data,
    };
  }
};

export const editTransaction = async (id, data) => {
  const response = await axios.put(`/transactions/${id}`, data);

  return response.data;
};

export const deleteTransaction = async (id) => {
  const response = axios.delete(`/transactions/${id}`);

  const resLanding = await axios.get(
    `/transactions/?_sort=id&_order=desc&_page=1&_limit=6`
  );
  const filterData = resLanding.data.filter((t) => t.id !== id);

  const resAllLanding = await axios.get(`/transactions`);

  const filterAllData = resAllLanding.data.filter((t) => t.id !== id);

  return {
    item: response?.data,
    landingData: filterData,
    allLanding: filterAllData,
  };
};
